import { Directive, OnInit, Input } from '@angular/core';
import { TemplateRef, ViewContainerRef } from '@angular/core';
import { AppConstants } from '../../core/constants/constants';

@Directive({
    selector: '[appHasPrivilage]',
    standalone: false
})
export class HasPrviageDirective implements OnInit {
    userPrivilages: string[] = JSON.parse(localStorage.getItem(AppConstants.PRISISTED_KEYS.USER_PERMISSIONS));
    privilages: string | string[]; // Accepts either a single privilege or an array of privileges

    @Input()
    set appHasPrivilage(privilages: string | string[]) {
        if (!privilages) {
            throw new Error('Privilege value is empty or missing');
        }
        this.privilages = privilages;
    }

    constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef) { }

    ngOnInit() {
        let hasAccess = false;

        // If the privilege is a string, convert it to an array
        if (typeof this.privilages === 'string') {
            this.privilages = [this.privilages];
        }

        // Check if the user has any of the privileges
        if (Array.isArray(this.privilages)) {
            hasAccess = this.privilages.some(priv => this.userPrivilages.indexOf(priv) !== -1);
        }

        // If the user has any of the privileges, display the element
        if (hasAccess) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }
}
